// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"78":"price","164":"terms","594":"about","694":"theme","962":"home","964":"product"}[chunkId] + "." + {"78":"9505fef5","164":"d0f6cc7b","594":"a4f5b234","694":"0c06b8f6","962":"b8d20e13","964":"cf8f3634"}[chunkId] + ".js";
};